/* Medicus — names the YMQ option groups for screen readers
   5 September 2026

   assets/mc-options-a11y.css puts the option radios and checkboxes back in the
   accessibility tree. This adds the one thing the markup still does not carry:
   the name of the group they belong to. Without it a screen reader announces
   "XL Captain (~56-60cm), radio button, 3 of 5" with no clue that the group is
   "Choose Your Scrub Cap Size".

   It writes two ARIA attributes on a wrapper YMQ already renders. It reads no
   option values, changes no state, and touches nothing else.

   LOOP SAFETY. The observer watches document.body, because YMQ re-renders the
   whole option column. Every write is guarded by the data-mc-a11y marker, so
   the mutations this makes cannot cause another pass to write anything. */
(function () {
  'use strict';

  var MARK = 'data-mc-a11y';

  function label(box) {
    var t = box.getAttribute('ymq-option-label');
    if (t && t.trim()) return t.trim();
    var head = box.querySelector('.ymq-option-title, .ymq_lable, .ymq-option-header');
    return head ? (head.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120) : '';
  }

  function apply() {
    var boxes = document.querySelectorAll('.ymq-options-box:not([' + MARK + '])');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var ins = box.querySelectorAll('input[ymq-option-value-id][type="radio"], input[ymq-option-value-id][type="checkbox"]');
      if (!ins.length) continue;

      var name = label(box);
      if (!name) continue;

      /* The nearest element that holds every input in the group, so the name
         lands on the group and not on the whole option box with its help text
         and its images. */
      var host = ins[0].closest('label');
      host = host && host.parentNode ? host.parentNode : box;
      for (var j = 1; j < ins.length; j++) {
        if (host.contains(ins[j])) continue;
        host = box;
        break;
      }

      /* Radios are one group; independent checkboxes are not, so they get the
         generic group role either way — it is the name that was missing. */
      if (!host.getAttribute('role')) host.setAttribute('role', 'group');
      if (!host.getAttribute('aria-label')) host.setAttribute('aria-label', name);
      box.setAttribute(MARK, '');
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; apply(); }, 120);   /* not rAF: frozen in a background tab */
  }

  function start() {
    apply();
    try {
      new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* one pass is better than none */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
